import { TOKEN, apiUrl } from "../Constants"
import api from "./ApiService"

const BASE_URL = apiUrl + "/api/master-data"

const authConfig = {
  headers: { Authorization: `Bearer ${TOKEN}` },
}

// Bank

export function createBank(data: any) {
  return api.post(`${BASE_URL}/banks/create`, data, authConfig)
}
export function updateBank(id: string, data: any) {
  return api.put(`${BASE_URL}/banks/edit/${id}`, data, authConfig)
}
export function getAllActiveBank(status: string) {
  return api.get(`${BASE_URL}/all-banks/${status}`)
}
export function getBankById(id: string) {
  return api.get(`${BASE_URL}/bank/${id}`, authConfig)
}

// Country

export function createCountry(data: any) {
  return api.post(`${BASE_URL}/countries/create`, data, authConfig)
}
export function updateCountry(id: string, data: any) {
  return api.put(`${BASE_URL}/countries/edit/${id}`, data, authConfig)
}
export function getAllActiveCountry(status: string) {
  return api.get(`${BASE_URL}/all-country/${status}`)
}
export function getCountryById(id: string) {
  return api.get(`${BASE_URL}/country/${id}`, authConfig)
}

// Country of National ID

export function createCountryNationalID(data: any) {
  return api.post(`${BASE_URL}/countriesofnid/create`, data, authConfig)
}
export function updateCountryNationalID(id: string, data: any) {
  return api.put(`${BASE_URL}/countriesofnid/edit/${id}`, data, authConfig)
}
export function getAllActiveCountryNationalID(status: string) {
  return api.get(`${BASE_URL}/all-countryofnid/${status}`)
}
export function getCountryNationalIDById(id: string) {
  return api.get(`${BASE_URL}/countryofnid/${id}`, authConfig)
}

// Religion

export function createReligion(data: any) {
  return api.post(`${BASE_URL}/religions/create`, data, authConfig)
}
export function updateReligion(id: string, data: any) {
  return api.put(`${BASE_URL}/religions/edit/${id}`, data, authConfig)
}
export function getAllActiveReligion(status: string) {
  return api.get(`${BASE_URL}/all-religion/${status}`)
}
export function getReligionById(id: string) {
  return api.get(`${BASE_URL}/religion/${id}`, authConfig)
}

// Marital Status

export function createMaritalStatus(data: any) {
  return api.post(`${BASE_URL}/marital-statuses/create`, data, authConfig)
}
export function updateMaritalStatus(id: string, data: any) {
  return api.put(`${BASE_URL}/marital-statuses/edit/${id}`, data, authConfig)
}
export function getAllActiveMaritalStatus(status: string) {
  return api.get(`${BASE_URL}/all-marital-status/${status}`)
}
export function getMaritalStatusById(id: string) {
  return api.get(`${BASE_URL}/marital-status/${id}`, authConfig)
}

// Company

export function createCompany(data: any) {
  return api.post(`${BASE_URL}/companies/create`, data, authConfig)
}
export function updateCompany(id: string, data: any) {
  return api.put(`${BASE_URL}/companies/edit/${id}`, data, authConfig)
}
export function getAllActiveCompany(status: any) {
  return api.get(`${BASE_URL}/all-company/${status}`)
}
export function getCompanyById(id: string) {
  return api.get(`${BASE_URL}/company/${id}`, authConfig)
}

// Pay Grade

export function createPayGrade(data: any) {
  return api.post(`${BASE_URL}/pay-grades/create`, data, authConfig)
}
export function updatePayGrade(id: string, data: any) {
  return api.put(`${BASE_URL}/pay-grades/edit/${id}`, data, authConfig)
}
export function getAllActivePayGrade(status: string) {
  return api.get(`${BASE_URL}/all-pay-grade/${status}`)
}
export function getPayGradeById(id: string) {
  return api.get(`${BASE_URL}/pay-grade/${id}`, authConfig)
}

// Incentive Group

export function createIncentiveGroup(data: any) {
  return api.post(`${BASE_URL}/incentive-groups/create`, data, authConfig)
}
export function updateIncentiveGroup(id: string, data: any) {
  return api.put(`${BASE_URL}/incentive-groups/edit/${id}`, data, authConfig)
}
export function getAllActiveIncentiveGroup(status: string) {
  return api.get(`${BASE_URL}/all-incentive-group/${status}`)
}
export function getIncentiveGroupById(id: string) {
  return api.get(`${BASE_URL}/incentive-group/${id}`, authConfig)
}

// Work Schedule (ONB Schedule)

export function createWorkSchedule(data: any) {
  return api.post(`${BASE_URL}/work-schedules/create`, data, authConfig)
}
export function updateWorkSchedule(id: string, data: any) {
  return api.put(`${BASE_URL}/work-schedules/edit/${id}`, data, authConfig)
}
export function getAllActiveWorkSchedule(status: string) {
  return api.get(`${BASE_URL}/all-work-schedule/${status}`)
}
export function getWorkScheduleById(id: string) {
  return api.get(`${BASE_URL}/work-schedule/${id}`, authConfig)
}

// Holiday Schedule (ONB Holiday Schedule)

export function createHolidaySchedule(data: any) {
  return api.post(`${BASE_URL}/holiday-schedules/create`, data, authConfig)
}
export function updateHolidaySchedule(id: string, data: any) {
  return api.put(`${BASE_URL}/holiday-schedules/edit/${id}`, data, authConfig)
}
export function getAllActiveHolidaySchedule(status: string) {
  return api.get(`${BASE_URL}/all-holiday-schedule/${status}`)
}
export function getHolidayScheduleById(id: string) {
  return api.get(`${BASE_URL}/holiday-schedule/${id}`, authConfig)
}

// Work Group

export function createWorkGroup(data: any) {
  return api.post(`${BASE_URL}/work-groups/create`, data, authConfig)
}
export function updateWorkGroup(id: string, data: any) {
  return api.put(`${BASE_URL}/work-groups/edit/${id}`, data, authConfig)
}
export function getAllActiveWorkGroup(status: string) {
  return api.get(`${BASE_URL}/all-work-group/${status}`)
}
export function getWorkGroupById(id: string) {
  return api.get(`${BASE_URL}/work-group/${id}`, authConfig)
}

// Pay Group

export function createPayGroup(data: any) {
  return api.post(`${BASE_URL}/pay-groups/create`, data, authConfig)
}
export function updatePayGroup(id: string, data: any) {
  return api.put(`${BASE_URL}/pay-groups/edit/${id}`, data, authConfig)
}
export function getAllActivePayGroup(status: string) {
  return api.get(`${BASE_URL}/all-pay-group/${status}`)
}
export function getPayGroupById(id: string) {
  return api.get(`${BASE_URL}/pay-group/${id}`, authConfig)
}

// Prefix

export function createPrefix(data: any) {
  return api.post(`${BASE_URL}/prefixes/create`, data, authConfig)
}
export function updatePrefix(id: string, data: any) {
  return api.put(`${BASE_URL}/prefixes/edit/${id}`, data, authConfig)
}
export function getAllActivePrefix(status: string) {
  return api.get(`${BASE_URL}/all-prefix/${status}`)
}
export function getPrefixById(id: string) {
  return api.get(`${BASE_URL}/prefix/${id}`, authConfig)
}

export function getAllActiveOTP() {
  return api.get(`${BASE_URL}/all-otp`)
}

// Status Time Log  (typically read-only — included for completeness)

export function createStatusTimeLog(data: any) {
  return api.post(`${BASE_URL}/status-time-logs/create`, data, authConfig)
}
export function updateStatusTimeLog(id: string, data: any) {
  return api.put(`${BASE_URL}/status-time-logs/edit/${id}`, data, authConfig)
}
export function getAllActiveStatusTimeLog(status: string) {
  return api.get(`${BASE_URL}/status-time-log/${status}`)
}
export function getStatusTimeLogById(id: string) {
  return api.get(`${BASE_URL}/status-time-log/${id}`, authConfig)
}

// SSO Hospital

export function createSSOHospital(data: any) {
  return api.post(`${BASE_URL}/sso-hospitals/create`, data, authConfig)
}
export function updateSSOHospital(id: string, data: any) {
  return api.put(`${BASE_URL}/sso-hospitals/edit/${id}`, data, authConfig)
}
export function getAllActiveSSOHospital(status: string) {
  return api.get(`${BASE_URL}/all-sso-hospital/${status}`)
}
export function getSSOHospitalById(id: string) {
  return api.get(`${BASE_URL}/sso-hospital/${id}`, authConfig)
}

// National ID Card Type

export function createNationalIDCardType(data: any) {
  return api.post(`${BASE_URL}/nationalId-card-types/create`, data, authConfig)
}
export function updateNationalIDCardType(id: string, data: any) {
  return api.put(
    `${BASE_URL}/nationalId-card-types/edit/${id}`,
    data,
    authConfig
  )
}
export function getAllActiveNationalIDCardType(status: string) {
  return api.get(`${BASE_URL}/all-nationalId-card-type/${status}`)
}
export function getNationalIDCardTypeById(id: string) {
  return api.get(`${BASE_URL}/nationalId-card-type/${id}`, authConfig)
}
 